import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

function Footer({ ...props }) {
  const { classes, fluid, white, t } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  return (
      <footer className={classes.footer}>
                  <div style={{ maxWidth: '800px' }}>
                      <div style={{ textAlign: 'center' }}>
                              <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.copyright-date', { 0: 1900 + new Date().getYear() }) }} />
                      </div>
                  </div>
      </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

export default compose(
    withStyles(footerStyle),
    withTranslation(),
)(Footer);
